export interface ChipProps {
  /** Chip label text */
  label: string;
  /** Color theme */
  theme?: 'info' | 'warning' | 'success' | 'danger';
  /** Size variant */
  size?: 'small' | 'large';
  /** Additional CSS class names */
  className?: string;
}

const THEME_STYLES: Record<string, { background: string; color: string }> = {
  info: { background: 'rgba(36, 153, 213, 0.15)', color: '#2499D5' },
  warning: { background: 'rgba(255, 152, 0, 0.15)', color: '#e68a00' },
  success: { background: 'rgba(68, 188, 99, 0.15)', color: '#44BC63' },
  danger: { background: 'rgba(220, 53, 69, 0.15)', color: '#dc3545' },
};

const DEFAULT_THEME = { background: '#f0f0f0', color: '#666' };

export function Chip({ label, theme, size = 'small', className }: ChipProps) {
  const { background, color } = theme ? THEME_STYLES[theme] : DEFAULT_THEME;

  const style: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: size === 'large' ? '0.85rem' : '0.7rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    lineHeight: 1.4,
    background,
    color,
  };

  return (
    <span className={className} style={style}>
      {label}
    </span>
  );
}

export default Chip;
